/**
 * @module state/failsafeSaga
 */

import { takeEvery } from "redux-saga/effects";
import logger from "lib/log";

import reportErrorSaga from "state/reportErrorSaga";
import { ERROR_FATAL, ERROR_WARNING, RELOAD } from "state/app/actions";

/**
 * Failsafe Saga - if all else fails, this saga should survive.
 * Deals with top-level error logging and possibly recovery.
 */
export default function* failsafeSaga() {

  // log and report errors
  yield takeEvery([ ERROR_FATAL, ERROR_WARNING ], reportErrorSaga);

  // allow the app to be refreshed after a fatal error
  yield takeEvery(RELOAD, reloadApp);

}

function reloadApp() {
  // this is only likely to throw in some weird environment,
  // e.g. a unit test
  try {
    window.location.reload();
  } catch (error) {
    logger.error("FailsafeSaga: reloadApp: ", error);
  }
}



// WEBPACK FOOTER //
// ./src/state/failsafeSaga.js